<template>
    <div class="container">
        <el-card>
            <div>
                <el-form label-position="right">
                    <el-form-item label="ID：" label-width="150px">
                        <div>{{ detailItem.id }}</div>
                    </el-form-item>
                    <el-form-item label="联系人：" label-width="150px">
                        <div>{{ detailItem.nickname }}</div>
                    </el-form-item>
                    <el-form-item label="联系电话(账号)：" label-width="150px">
                        <div>{{ detailItem.mobile }}</div>
                    </el-form-item>
                    <el-form-item label="注册时间：" label-width="150px">
                        <div>{{ detailItem.create_time }}</div>
                    </el-form-item>
                    <el-form-item label="上次登录时间：" label-width="150px">
                        <div>{{ detailItem.last_login }}</div>
                    </el-form-item>

                    <el-form-item label="认证类型：" label-width="150px">
                        <div>{{ getUType(detailItem.uType) }}</div>
                    </el-form-item>
                    <el-form-item label="认证状态：" label-width="150px">
                        <div>{{ getUStatus(detailItem.uStatus) }}</div>
                    </el-form-item>
                    <el-form-item :label="getTitleName(detailItem.uType)" label-width="150px" v-if="detailItem.uType !== 0">
                        <div>{{ detailItem.uName }}</div>
                    </el-form-item>
                    <el-form-item :label="getTitleIdentity(detailItem.uType)" label-width="150px" v-if="detailItem.uType !== 0">
                        <div>{{ detailItem.id_card }}</div>
                    </el-form-item>
                    <el-form-item label="身份证照片：" v-if="detailItem.uType !== 0">
                        <div class="box">
                            <div><span>正面照片</span><img class="detail-image" :src="`data:image/*;base64,${front_url}`" alt="" @click="previewImage(front_url)"></div>
                            <div><span>反面照片</span><img class="detail-image" :src="`data:image/*;base64,${back_url}`" alt="" @click="previewImage(back_url)"></div>
                        </div>
                    </el-form-item>
                    <el-form-item label="从业机构名称：" label-width="150px" v-if="detailItem.uType === 1">
                        <div>{{ detailItem.person_organization_name }}</div>
                    </el-form-item>
                    <el-form-item label="职业证编号：" label-width="150px" v-if="detailItem.uType === 1">
                        <div>{{ detailItem.person_certificate_id }}</div>
                    </el-form-item>
                    <el-form-item label="企业名称：" label-width="150px" v-if="detailItem.uType === 2">
                        <div>{{ detailItem.company_name }}</div>
                    </el-form-item>
                    <el-form-item label="企业统一社会信用代码：" label-width="150px" v-if="detailItem.uType === 2">
                        <div>{{ detailItem.company_id }}</div>
                    </el-form-item>
                    <el-form-item label="工商执照："  v-if="detailItem.uType === 2">
                        <img class="detail-image" :src="`data:image/*;base64,${company_license_url}`" alt="" style="width: 264px; height: 160px;" @click="previewImage(company_license_url)">
                    </el-form-item>
                    <el-form-item label="平台名称：" label-width="150px" v-if="detailItem.uType === 2">
                        <div>{{ detailItem.company_platform_name }}</div>
                    </el-form-item>
                    <el-form-item label="备注：" label-width="150px" v-if="detailItem.uType === 2">
                        <div>{{ detailItem.company_remark }}</div>
                    </el-form-item>
                    <el-form-item label="认证失败原因	：" label-width="150px" v-if="detailItem.uStatus === 3">
                        <div>{{ detailItem.fatal_reason }}</div>
                    </el-form-item>
                    <!--                <el-form-item label="最后一次申请时间：" label-width="150px">
                                        <el-input v-model="listItem.last_apply_time" disabled></el-input>
                                    </el-form-item> 
                                    <el-form-item label="最后一次审核时间：" label-width="150px">
                                        <el-input v-model="listItem.last_audit_time" disabled></el-input>
                                    </el-form-item>-->

                    <el-form-item label="账户名：" label-width="150px">
                        <div>{{ financeConfig.bank_account_name }}</div>
                    </el-form-item>
                    <el-form-item label="银行卡号：" label-width="150px">
                        <div>{{ financeConfig.bank_card_id }}</div>
                    </el-form-item>
                    <el-form-item label="银行：" label-width="150px">
                        <div>{{ financeConfig.opening_bank }}</div>
                    </el-form-item>
                    <el-form-item label="开户行：" label-width="150px">
                        <div>{{ financeConfig.opening_bank_detail }}</div>
                    </el-form-item>
                    <el-form-item label="佣金率：" label-width="150px">
                        <div class="detail_rate_box">
                            <div><span>模板id：</span><span>{{ settlementRateTemplate.id }}</span></div>
                            <div><span>模板名称：</span><span>{{ settlementRateTemplate.name }}</span></div>
                            <div><span>默认：</span><span>{{ forMatterRate(settlementRateTemplate.default) }}</span></div>
                            <div><span>YB：</span><span>{{ forMatterRate(settlementRateTemplate.iyunfu) }}</span></div>
                            <div><span>HZ：</span><span>{{ forMatterRate(settlementRateTemplate.qixin) }}</span></div>
                            <div><span>YS：</span><span>{{ forMatterRate(settlementRateTemplate.niubao) }}</span></div>
                            <div><span>WT：</span><span>{{ forMatterRate(settlementRateTemplate.fengqi) }}</span></div>
                            <div><span>更新时间：</span><span>{{ settlementRateTemplate.create_time }}</span></div>
                        </div>
                    </el-form-item>
                    <el-form-item label="税率：" label-width="150px">
                        <div class="detail_rate_box">
                            <div><span>模板id：</span><span>{{ taxRateTemplate.id }}</span></div>
                            <div><span>模板名称：</span><span>{{ taxRateTemplate.name }}</span></div>
                            <div><span>税率：</span><span>{{ forMatterRate(taxRateTemplate.rate) }}</span></div>
                            <div><span>更新时间：</span><span>{{ taxRateTemplate.create_time }}</span></div>
                        </div>
                    </el-form-item>
                    <el-form-item label-width="150px">
                        <el-button
                            size="mini"
                            type="primary"
                            @click="handleShowDialog"
                        >设置费率</el-button>
                    </el-form-item>

<!--                    <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end;">
                        <el-button type="primary" size="small" @click="handleDetailDialogClose">确定</el-button>
                    </div>-->
                </el-form>
                <el-dialog :visible.sync="dialogShow" title="设置佣金率和税率" :modal-append-to-body="true" append-to-body>
                    <SettingRate :userId="setRateUserId" @handleCloseSettingRateDialog="handleCloseSettingRateDialog"></SettingRate>
                </el-dialog>
            </div>
        </el-card>
        <el-dialog :visible.sync="imageViewDialogShow" :before-close="handleImageViewDialogClose">
            <div style="display: flex;flex-direction: row;align-items: center;justify-content: center;width: 80%; margin: 0 auto;">
                <img :src="`data:image/*;base64,${imageUrl}`" alt="" style="max-width: 380px;height: auto;">
            </div>
        </el-dialog>
    </div>
    
</template>
<script>
import request from "@/api/request";
import SettingRate from "@/modules/saas/SettingRate.vue"
export default {
    props: {
        userId: String
    },
    components: {
        SettingRate
    },
    data() {
        return {
            financeConfig: {},
            detailDialogShow: false,
            detailItem: {},
            typeOptions: [{value: 111, desc: '全部'},{value: 1, desc: '云服'},{value: 2, desc: '齐欣'},{value: 3, desc: '牛保'},{value: 4, desc: '凤栖'}],
            uTypeOptions: ['未认证',  '个人用户', '企业用户'],
            uStatusOptions: ['审核中',  '认证成功', '认证失败', '未认证'],
            front_url: '',
            back_url: '',
            company_license_url: '',
            rate: {},
            settlementRateTemplate: {},
            taxRateTemplate: {},
            dialogShow: false,
            imageViewDialogShow: false,
            imageUrl: ''
        }
    },
    watch: {
        userId(n){
            if(n) {
                this.getUserInfo()
            }
        }
    },
    computed: {
        setRateUserId(){
            return this.userId
        }
    },
    mounted() {
        //console.log(this.userId)
        if(this.userId && this.userId !== '0') {
            this.getUserInfo()
        }
    },
    methods: {
        previewImage(url){
            this.imageUrl = url
            this.imageViewDialogShow = !this.imageViewDialogShow
        },
        handleImageViewDialogClose(){
            this.imageViewDialogShow = !this.imageViewDialogShow
            this.imageUrl = ''
        },
        //用户详情
        getUserInfo(){
            if(this.userId === '0') return
            this.handleFinanceInfoShowDialog(this.userId )
            /*
            {"user_id":"1425746338322063360"}:http://api.admin.vm33.finadv.cn/saas/uc/settlement/get_user_finance_config.php
            {"user_id":"1432597571628441600"}:http://api.admin.vm33.finadv.cn/saas/uc/settlement/get_user_finance_config.php
            
            */
            
            //获取佣金率和税率
            request.saas
                .post('settlement/get_user_settlement_config', {
                    user_id: this.userId
                })
                .then(res => {
                    this.rate = res.data
                    this.settlementRateTemplate.id = res.data.settlement_rate_template.id
                    this.settlementRateTemplate.name = res.data.settlement_rate_template.name
                    this.settlementRateTemplate.default = res.data.settlement_rate_template.rates.default
                    this.settlementRateTemplate.iyunfu = res.data.settlement_rate_template.rates.iyunfu
                    this.settlementRateTemplate.qixin = res.data.settlement_rate_template.rates.qixin
                    this.settlementRateTemplate.niubao = res.data.settlement_rate_template.rates.niubao
                    this.settlementRateTemplate.fengqi = res.data.settlement_rate_template.rates.fengqi
                    this.settlementRateTemplate.create_time = res.data.settlement_rate_template.create_time
                    this.taxRateTemplate.id = res.data.tax_rate_template.id
                    this.taxRateTemplate.name = res.data.tax_rate_template.name
                    this.taxRateTemplate.rate = res.data.tax_rate_template.rate
                    this.taxRateTemplate.create_time = res.data.tax_rate_template.create_time
                    this.taxId = res.data.tax_rate_template.id
                    this.settlementId = res.data.settlement_rate_template.id
                })
            request.saas.post("uc/get_user_detail", {
                id: this.userId
            })
                .then(resp => {
                    this.detailItem = resp.data
                    this.detailItem.id = resp.data.id
                    this.detailItem.type = resp.data.user_info.type
                    this.detailItem.name = resp.data.user_info.name
                    this.detailItem.nickname = resp.data.user_info.nickname
                    this.detailItem.mobile = resp.data.user_info.mobile
                    this.detailItem.last_login = resp.data.user_info.last_login
                    this.detailItem.create_time = resp.data.user_info.create_time

                    this.detailItem.company_id = resp.data.user_certificate_info.company_id
                    //this.detailItem.company_license_url = resp.data.user_certificate_info.company_license_url
                    this.detailItem.company_name = resp.data.user_certificate_info.company_name
                    this.detailItem.extra = resp.data.user_certificate_info.extra
                    this.detailItem.id_card = resp.data.user_certificate_info.id_card

                    this.detailItem.last_apply_time = resp.data.user_certificate_info.last_apply_time
                    this.detailItem.last_audit_time = resp.data.user_certificate_info.last_audit_time
                    this.detailItem.uName = resp.data.user_certificate_info.name || '--'
                    this.detailItem.uStatus = resp.data.user_certificate_info.status
                    this.detailItem.uType = resp.data.user_certificate_info.type
                    this.detailItem.fatal_reason = resp.data.user_certificate_info.extra.fatal_reason
                    this.detailItem.company_platform_name = resp.data.user_certificate_info.extra.company_platform_name
                    this.detailItem.company_remark = resp.data.user_certificate_info.extra.company_remark
                    this.detailItem.person_certificate_id = resp.data.user_certificate_info.extra.person_certificate_id
                    this.detailItem.person_organization_name = resp.data.user_certificate_info.extra.person_organization_name

                    if(resp.data.user_certificate_info.company_license_url) {
                        //企业用户,个人用户没有营业执照
                        this.getIdentityPhoto(3,resp.data.user_certificate_info.company_license_url)
                    }
                    if(resp.data.user_certificate_info.id_card_front_url) {
                        this.getIdentityPhoto(1,resp.data.user_certificate_info.id_card_front_url)
                    }
                    if(resp.data.user_certificate_info.id_card_front_url) {
                        this.getIdentityPhoto(2,resp.data.user_certificate_info.id_card_back_url)
                    }

                })
        },
        handleFinanceInfoShowDialog(user_id){
            request.saas
                .post('uc/settlement/get_user_finance_config', {
                    user_id: user_id
                })
                .then(res => {
                    
                    this.financeConfig = res.data
                    //console.log(this.financeConfig)
                    //this.handleFinanceDialogClose()
                })
        },
        handleDetailDialogClose(){
            this.back_url = ''
            this.front_url = ''
            this.company_license_url = ''
            this.listItem = {}
            this.$emit('handleDetailDialogClose')
        },
        getType(type) {
            for (const opt of this.typeOptions) {
                if(type === opt.value) {
                    return opt.desc
                }
            }
        },
        getUType(type){
            return this.uTypeOptions[type]
        },
        getUStatus(status) {
            return this.uStatusOptions[status-1]
        },
        getTitleName(uType) {
            return uType === 1 ? '姓名:': uType === '2' ? '法人姓名:' : ''
        },
        getTitleIdentity(uType) {
            return uType === 1 ? '身份证号:': uType === '2' ? '法人证件号:' : ''
        },
        forMatterRate(rate){
            return (rate/100).toFixed(2) + '%'
        },
        getIdentityPhoto(type, filename){
            request.saas.post("common/get_private_object", {
                filename: filename
            }).then(res => {
                if(type === 1) {
                    this.front_url = res.data.content
                } else if(type === 2) {
                    this.back_url = res.data.content
                } else if(type === 3) {
                    this.company_license_url = res.data.content
                }
            })
        },
        //设置费率
        handleShowDialog(){
            this.handleCloseSettingRateDialog()
        },
        handleCloseSettingRateDialog(){
            this.dialogShow = !this.dialogShow
        }
    }
}
</script>
<style scoped>
.container {
    padding: 0 5px;
}
.el-form-item{
    margin-bottom: 0;
}
.box{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
}
.box div{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.box div span{
    color: #191919;
    font-size: 14px;
    margin: 14px 0;
}
.box div img{
    width: 140px;
    height: 100px;
}
</style>
